import React, { useState } from 'react';
import { AlertCircle } from 'lucide-react';
import './InlineError.scss';

export interface InlineErrorProps {
  /** Error message to display */
  message: string;
  /** Maximum characters before truncation (default: 100) */
  maxLength?: number;
  /** Additional CSS class names */
  className?: string;
}

/**
 * Reusable inline error component with icon, truncation, and tooltip
 */
export const InlineError: React.FC<InlineErrorProps> = ({
  message,
  maxLength = 100,
  className = '',
}) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const shouldTruncate = message.length > maxLength;
  const displayMessage = shouldTruncate
    ? `${message.slice(0, maxLength)}...`
    : message;

  return (
    <div
      className={`inline-error ${className}`}
      onMouseEnter={() => shouldTruncate && setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <AlertCircle className="inline-error__icon" size={14} />
      <span className="inline-error__text">{displayMessage}</span>
      {showTooltip && <div className="inline-error__tooltip">{message}</div>}
    </div>
  );
};

export default InlineError;
